import { sellerApiClient } from "./sellerApiClient";

type Texts = {
  CN: string;
  EN: string;
  RU: string;
  TR: string;
}

export interface TQuestionTemplate {
  id: number;
  questionTemplate: Texts;
  answerTemplates: {
    id: number;
    answerTemplate: Texts;
  }[];
}

export interface TQuestions {
  questionTemplates: TQuestionTemplate[];
}

export interface TAnswer {
  questionTemplateId: number;
  answerTemplateId: number;
  detailedAnswer: string;
}

export interface TAnswers {
  answers: TAnswer[];
}

export const getQuestions = async (): Promise<TQuestions> => {
  const response = await sellerApiClient.get<TQuestions>(
    `/v1/surveys/current-survey`
  );

  return response.data;
};

export const sendAnswers = async ({
  isSkipped,
  answers,
}: {
  isSkipped: boolean;
  answers: TAnswer[];
}): Promise<void> => {
  const response = await sellerApiClient.post<void>(
    `v1/surveys/answer`,
    {
      isSkipped,
      answers: isSkipped ? null : answers,
    },
  );

  return response.data;
};
